import { CONSTANTS } from '../data.js';

export const getRarityColor = (rarity) => {
  return CONSTANTS.RARITY_COLORS[rarity] || CONSTANTS.RARITY_COLORS['Basic'];
};

export const getRarityGlow = (rarity) => {
  return CONSTANTS.RARITY_GLOWS[rarity] || CONSTANTS.RARITY_GLOWS['Basic'];
};

export const getElementColor = (element) => {
  return CONSTANTS.ELEMENT_COLORS[element] || CONSTANTS.ELEMENT_COLORS['Fire'];
};

export const getElementGlow = (element) => {
  return CONSTANTS.ELEMENT_GLOWS[element] || CONSTANTS.ELEMENT_GLOWS['Fire'];
};

export const groupDragonsByRarity = () => {
  const grouped = {};
  const rarityOrder = ['Basic', 'Common', 'Uncommon', 'Rare', 'Elite', 'Epic', 'Legendary', 'Mythical', 'Ancestral'];
  
  Object.values(CONSTANTS.DRAGONS).forEach(dragon => {
    if (!grouped[dragon.rarity]) {
      grouped[dragon.rarity] = [];
    }
    grouped[dragon.rarity].push(dragon);
  });

  // Sort each rarity group by value
  Object.keys(grouped).forEach(rarity => {
    grouped[rarity].sort((a, b) => a.value - b.value);
  });

  // Return in rarity order
  const result = {};
  rarityOrder.forEach(rarity => {
    if (grouped[rarity]) {
      result[rarity] = grouped[rarity];
    }
  });

  return result;
};

export const filterShopDragons = (unlockedDragons) => {
  return Object.values(CONSTANTS.DRAGONS)
    .filter(d => unlockedDragons.includes(d.name))
    .sort((a, b) => a.value - b.value);
};
